// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__12iGr","inputWrap":"styles_inputWrap__18YAx","input":"styles_input__33ULW"};